// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bMXi","footer":"styles_footer__FAhDB"};